<template>
  <div class="settings columns container">
    <setting-intro-banner
      :header-image="inbox.avatarUrl"
      :header-title="inboxName"
    >
      <div class="settings--tabs-wrapper" ref="tabsWrapper">
        <woot-tabs
          class="settings--tabs"
          :index="mainTabsIndex"
          :border="false"
          @change="onMainTabChange"
        >
          <woot-tabs-item
            v-for="tab in mainTabs"
            :key="tab.key"
            :name="tab.name"
            :show-badge="false"
          />
          <!-- Abinha "Mais" -->
          <woot-tabs-item
            :name="$t('INBOX_MGMT.TABS.MORE')"
            :show-badge="false"
            class="extra-tabs-trigger"
            ref="extraButton"
            @click.native.stop="toggleExtraMenu"
          />
        </woot-tabs>

        <!-- Dropdown com as abas extras -->
        <ul
          v-show="showExtraMenu"
          class="extra-tabs__menu"
          ref="extraMenu"
          :style="extraMenuStyle"
        >
          <li
            v-for="tab in extraTabs"
            :key="tab.key"
            @click="selectExtraTab(tab)"
            class="extra-tabs__item"
          >
            {{ tab.name }}
          </li>
        </ul>
      </div>
    </setting-intro-banner>

    <div v-if="selectedTabKey === 'inbox_settings'" class="settings--content">
      <settings-section
        :title="$t('INBOX_MGMT.SETTINGS_POPUP.INBOX_UPDATE_TITLE')"
        :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.INBOX_UPDATE_SUB_TEXT')"
      >
        <woot-avatar-uploader
          :label="$t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_AVATAR.LABEL')"
          :src="avatarUrl"
          class="settings-item"
          delete-avatar
          @change="handleImageUpload"
          @onAvatarDelete="handleAvatarDelete"
        />
        <woot-input
          v-model.trim="selectedInboxName"
          class="medium-9 columns settings-item"
          :class="{ error: $v.selectedInboxName.$error }"
          :label="inboxNameLabel"
          :placeholder="inboxNamePlaceHolder"
          :error="
            $v.selectedInboxName.$error
              ? $t('INBOX_MGMT.ADD.CHANNEL_NAME.ERROR')
              : ''
          "
          @blur="$v.selectedInboxName.$touch"
        />
        <label
          v-if="isATwitterInbox"
          for="toggle-business-hours"
          class="toggle-input-wrap"
        >
          <input
            v-model="tweetsEnabled"
            type="checkbox"
            name="toggle-business-hours"
          />
          {{ $t('INBOX_MGMT.ADD.TWITTER.TWEETS.ENABLE') }}
        </label>
        <woot-input
          v-if="isAPIInbox"
          v-model.trim="webhookUrl"
          class="medium-9 columns settings-item"
          :class="{ error: $v.webhookUrl.$error }"
          :label="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.LABEL')
          "
          :placeholder="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.PLACEHOLDER')
          "
          :error="
            $v.webhookUrl.$error
              ? $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.ERROR')
              : ''
          "
          @blur="$v.webhookUrl.$touch"
        />
        <woot-input
          v-if="isAWebWidgetInbox"
          v-model.trim="channelWebsiteUrl"
          class="medium-9 columns settings-item"
          :label="$t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_DOMAIN.LABEL')"
          :placeholder="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_DOMAIN.PLACEHOLDER')
          "
        />
        <woot-input
          v-if="isAWebWidgetInbox"
          v-model.trim="channelWelcomeTitle"
          class="medium-9 columns settings-item"
          :label="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TITLE.LABEL')
          "
          :placeholder="
            $t(
              'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TITLE.PLACEHOLDER'
            )
          "
        />

        <woot-input
          v-if="isAWebWidgetInbox"
          v-model.trim="channelWelcomeTagline"
          class="medium-9 columns settings-item"
          :label="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TAGLINE.LABEL')
          "
          :placeholder="
            $t(
              'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TAGLINE.PLACEHOLDER'
            )
          "
        />

        <label v-if="isAWebWidgetInbox" class="medium-9 columns settings-item">
          {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.WIDGET_COLOR.LABEL') }}
          <woot-color-picker v-model="inbox.widget_color" />
        </label>

        <label v-if="isAWhatsAppChannel" class="medium-9 columns settings-item">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.LABEL') }}
          <input v-model="whatsAppAPIProviderName" type="text" disabled />
        </label>

        <label class="medium-9 columns settings-item">
          {{
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.LABEL')
          }}
          <select v-model="greetingEnabled">
            <option :value="true">
              {{
                $t(
                  'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.ENABLED'
                )
              }}
            </option>
            <option :value="false">
              {{
                $t(
                  'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.DISABLED'
                )
              }}
            </option>
          </select>
          <p class="help-text">
            {{
              $t(
                'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.HELP_TEXT'
              )
            }}
          </p>
        </label>
        <div v-if="greetingEnabled" class="settings-item">
          <greetings-editor
            v-model.trim="greetingMessage"
            :label="
              $t(
                'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_MESSAGE.LABEL'
              )
            "
            :placeholder="
              $t(
                'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_MESSAGE.PLACEHOLDER'
              )
            "
            :richtext="!textAreaChannels"
          />
          <hr>
        </div>
        <label class="medium-9 columns settings-item">
          Abrir conversa quando o agente enviar uma mensagem
          <select v-model="openConversationEnabled">
            <option :value="true">Ativado</option>
            <option :value="false">Desativado</option>
          </select>
          <p class="help-text">
            Abre automaticamente a conversa e atribui a mesma ao último agente
            que enviou uma informação para o cliente
          </p>
        </label>

        <label v-if="isAWebWidgetInbox" class="medium-9 columns settings-item">
          {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.TITLE') }}
          <select v-model="replyTime">
            <option key="in_a_few_minutes" value="in_a_few_minutes">
              {{
                $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.IN_A_FEW_MINUTES')
              }}
            </option>
            <option key="in_a_few_hours" value="in_a_few_hours">
              {{
                $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.IN_A_FEW_HOURS')
              }}
            </option>
            <option key="in_a_day" value="in_a_day">
              {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.IN_A_DAY') }}
            </option>
          </select>

          <p class="help-text">
            {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.HELP_TEXT') }}
          </p>
        </label>

        <label v-if="isAWebWidgetInbox" class="medium-9 columns settings-item">
          {{ $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX') }}
          <select v-model="emailCollectEnabled">
            <option :value="true">
              {{ $t('INBOX_MGMT.EDIT.EMAIL_COLLECT_BOX.ENABLED') }}
            </option>
            <option :value="false">
              {{ $t('INBOX_MGMT.EDIT.EMAIL_COLLECT_BOX.DISABLED') }}
            </option>
          </select>
          <p class="help-text">
            {{
              $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT')
            }}
          </p>
        </label>

        <label v-if="isAWebWidgetInbox" class="medium-9 columns settings-item">
          {{ $t('INBOX_MGMT.SETTINGS_POPUP.ALLOW_MESSAGES_AFTER_RESOLVED') }}
          <select v-model="allowMessagesAfterResolved">
            <option :value="true">
              {{ $t('INBOX_MGMT.EDIT.ALLOW_MESSAGES_AFTER_RESOLVED.ENABLED') }}
            </option>
            <option :value="false">
              {{ $t('INBOX_MGMT.EDIT.ALLOW_MESSAGES_AFTER_RESOLVED.DISABLED') }}
            </option>
          </select>
          <p class="help-text">
            {{
              $t(
                'INBOX_MGMT.SETTINGS_POPUP.ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT'
              )
            }}
          </p>
        </label>

        <label v-if="isAWebWidgetInbox" class="medium-9 columns settings-item">
          {{ $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_CONTINUITY_VIA_EMAIL') }}
          <select v-model="continuityViaEmail">
            <option :value="true">
              {{ $t('INBOX_MGMT.EDIT.ENABLE_CONTINUITY_VIA_EMAIL.ENABLED') }}
            </option>
            <option :value="false">
              {{ $t('INBOX_MGMT.EDIT.ENABLE_CONTINUITY_VIA_EMAIL.DISABLED') }}
            </option>
          </select>
          <p class="help-text">
            {{
              $t(
                'INBOX_MGMT.SETTINGS_POPUP.ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT'
              )
            }}
          </p>
        </label>
        <div class="medium-9 settings-item settings-item">
          <label>
            {{ $t('INBOX_MGMT.HELP_CENTER.LABEL') }}
          </label>
          <select v-model="selectedPortalSlug" class="filter__question">
            <option value="">
              {{ $t('INBOX_MGMT.HELP_CENTER.PLACEHOLDER') }}
            </option>
            <option v-for="p in portals" :key="p.slug" :value="p.slug">
              {{ p.name }}
            </option>
          </select>
          <p class="help-text">
            {{ $t('INBOX_MGMT.HELP_CENTER.SUB_TEXT') }}
          </p>
        </div>
        <div v-if="canLocktoSingleConversation">
          <label
            class="medium-9 columns settings-item"
          >
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.LOCK_TO_SINGLE_CONVERSATION') }}
            <select v-model="locktoSingleConversation">
              <option :value="true">
                {{ $t('INBOX_MGMT.EDIT.LOCK_TO_SINGLE_CONVERSATION.ENABLED') }}
              </option>
              <option :value="false">
                {{ $t('INBOX_MGMT.EDIT.LOCK_TO_SINGLE_CONVERSATION.DISABLED') }}
              </option>
            </select>
            <p class="help-text">
              {{
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT'
                )
              }}
            </p>
          </label>
          <div v-if="!locktoSingleConversation" class="medium-9 columns settings-item">
            <label>
              <input
                id="enableLocktoSingleConversationHours"
                v-model="enableLocktoSingleConversationHours"
                type="checkbox"
              />
              {{ $t('INBOX_MGMT.EDIT.LOCK_TO_SINGLE_CONVERSATION_HOURS.LABEL_ENABLE') }}
            </label>
            <select v-if="enableLocktoSingleConversationHours" v-model="locktoSingleConversationHours" class="margin-bottom-0">
                <option :value="1">
                  {{ $t('INBOX_MGMT.EDIT.LOCK_TO_SINGLE_CONVERSATION_HOURS.OPTION_LABEL_HOUR') }}
                </option>
                <option v-for="qtd in [2, 6, 12]" :value="qtd" :key="`option-${qtd}-hours`">
                  {{ $t('INBOX_MGMT.EDIT.LOCK_TO_SINGLE_CONVERSATION_HOURS.OPTION_LABEL_HOURS', { hours: qtd }) }}
                </option>
                <option :value="24">
                  {{ $t('INBOX_MGMT.EDIT.LOCK_TO_SINGLE_CONVERSATION_HOURS.OPTION_LABEL_DAY') }}
                </option>
                <option v-for="qtd in [2, 3, 7, 14, 30, 45, 60, 90, 180, 364]" :value="(qtd*24)" :key="`option-${qtd}-days`">
                  {{ (qtd == 364 ? $t('INBOX_MGMT.EDIT.LOCK_TO_SINGLE_CONVERSATION_HOURS.OPTION_LABEL_YEAR') : $t('INBOX_MGMT.EDIT.LOCK_TO_SINGLE_CONVERSATION_HOURS.OPTION_LABEL_DAYS', { days: qtd })) }}
                </option>
            </select>
            <hr>
          </div>
        </div>

        <label v-if="isAWhatsAppChannel" class="medium-9 columns settings-item">
          {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.SEND_SIGNATURE.LABEL') }}
          <select v-model="sendMessageSignature">
            <option :value="true">
              {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.SEND_SIGNATURE.ENABLED') }}
            </option>
            <option :value="false">
              {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.SEND_SIGNATURE.DISABLED') }}
            </option>
          </select>
          <p class="help-text">
            {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.SEND_SIGNATURE.HELP_TEXT') }}
          </p>
        </label>

        <label
          v-if="is360DialogCloudWhatsAppChannel"
          class="medium-9 columns settings-item"
        >
          {{
            $t('INBOX_MGMT.SETTINGS_POPUP.BLOCK_TEMPLATES_ON_LOW_QUALITY.LABEL')
          }}
          <select v-model="blockTemplatesOnLowQuality">
            <option :value="true">
              {{
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.BLOCK_TEMPLATES_ON_LOW_QUALITY.ENABLED'
                )
              }}
            </option>
            <option :value="false">
              {{
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.BLOCK_TEMPLATES_ON_LOW_QUALITY.DISABLED'
                )
              }}
            </option>
          </select>
          <p class="help-text">
            {{
              $t(
                'INBOX_MGMT.SETTINGS_POPUP.BLOCK_TEMPLATES_ON_LOW_QUALITY.HELP_TEXT'
              )
            }}
          </p>
        </label>

        <label v-if="isAWebWidgetInbox">
          {{ $t('INBOX_MGMT.FEATURES.LABEL') }}
        </label>
        <div
          v-if="isAWebWidgetInbox"
          class="widget--feature-flag settings-item"
        >
          <input
            v-model="selectedFeatureFlags"
            type="checkbox"
            value="attachments"
            @input="handleFeatureFlag"
          />
          <label for="attachments">
            {{ $t('INBOX_MGMT.FEATURES.DISPLAY_FILE_PICKER') }}
          </label>
        </div>
        <div v-if="isAWebWidgetInbox" class="settings-item settings-item">
          <input
            id="audio_messages"
            v-model="selectedFeatureFlags"
            type="checkbox"
            value="audio_messages"
            @input="handleFeatureFlag"
          />
          <label for="audio_messages">
            {{ $t('INBOX_MGMT.FEATURES.ALLOW_AUDIO_MESSAGES') }}
          </label>
        </div>
        <div v-if="isAWebWidgetInbox" class="settings-item settings-item">
          <input
            v-model="selectedFeatureFlags"
            type="checkbox"
            value="emoji_picker"
            @input="handleFeatureFlag"
          />
          <label for="emoji_picker">
            {{ $t('INBOX_MGMT.FEATURES.DISPLAY_EMOJI_PICKER') }}
          </label>
        </div>
        <div v-if="isAWebWidgetInbox" class="settings-item settings-item">
          <input
            v-model="selectedFeatureFlags"
            type="checkbox"
            value="end_conversation"
            @input="handleFeatureFlag"
          />
          <label for="end_conversation">
            {{ $t('INBOX_MGMT.FEATURES.ALLOW_END_CONVERSATION') }}
          </label>
        </div>
        <div v-if="isAWebWidgetInbox" class="settings-item settings-item">
          <input
            v-model="selectedFeatureFlags"
            type="checkbox"
            value="use_inbox_avatar_for_bot"
            @input="handleFeatureFlag"
          />
          <label for="emoji_picker">
            {{ $t('INBOX_MGMT.FEATURES.USE_INBOX_AVATAR_FOR_BOT') }}
          </label>
        </div>

        <woot-submit-button
          v-if="isAPIInbox"
          type="submit"
          :disabled="$v.webhookUrl.$invalid"
          :button-text="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE')"
          :loading="uiFlags.isUpdating"
          @click="updateInbox"
        />
        <woot-submit-button
          v-else
          type="submit"
          :disabled="$v.$invalid"
          :button-text="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE')"
          :loading="uiFlags.isUpdating"
          @click="updateInbox"
        />
      </settings-section>
      <facebook-reauthorize v-if="isAFacebookInbox" :inbox-id="inbox.id" />
    </div>

    <div v-if="selectedTabKey === 'collaborators'" class="settings--content">
      <collaborators-page :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'csat'">
      <customer-satisfaction-page :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'auto_summary'">
      <auto-summary-page :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'configuration'">
      <configuration-page :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'reauthorization'">
      <reauthorization-page
        :inbox="inbox"
        :is-refreshing-whatsapp-token="isRefreshingWhatsappToken"
        :is-requesting-whatsapp-authorization="
          isRequestingWhatsappAuthorization
        "
        @force-token-refresh="forceTokenRefresh"
        @request-whatsapp-reauthorization="requestWhatsappReauthorization"
      />
    </div>
    <div v-if="selectedTabKey === 'preChatForm'">
      <pre-chat-form-settings :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'businesshours'">
      <weekly-availability :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'widgetBuilder'">
      <widget-builder :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'botConfiguration'">
      <bot-configuration :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'wppconnect'">
      <wppconnect-configuration :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'whatsapp_web'">
      <whatsappweb-configuration :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'file_permission'">
      <file-permission-page :inbox="inbox" />
    </div>
    <div v-if="isAdmin && selectedTabKey === 'whatsapp_templates'">
      <whatsapp-templates-page :inbox="inbox" />
    </div>
    <div v-if="isAdmin && selectedTabKey === 'whatsapp_templates_admin'">
      <whatsapp-templates-page :inbox="inbox" :only-admin="true" />
    </div>
    <div v-if="isAdmin && selectedTabKey === 'template_parameterization'">
      <template-parameterization-page :inbox="inbox" />
    </div>
    <div v-if="isAdmin && selectedTabKey === 'call_settings'">
      <call-settings-page :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'closing_reasons'">
      <closing-reasons-page :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'number_quality'">
      <inbox-quality-settings :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'business_manager'">
      <business-manager-settings :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'migrate_manager'">
      <migrate-manager-settings :inbox="inbox" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { shouldBeUrl } from 'shared/helpers/Validators';
import configMixin from 'shared/mixins/configMixin';
import alertMixin from 'shared/mixins/alertMixin';
import SettingIntroBanner from 'dashboard/components/widgets/SettingIntroBanner';
import SettingsSection from '../../../../components/SettingsSection';
import inboxMixin from 'shared/mixins/inboxMixin';
import adminMixin from 'dashboard/mixins/isAdmin';
import whatsappChannel from 'dashboard/api/channel/whatsappChannel';
import {
  setupFacebookSdk,
  initWhatsAppEmbeddedSignup,
  createMessageHandler,
  isValidBusinessData,
} from './channels/whatsapp/utils';
import FacebookReauthorize from './facebook/Reauthorize';
import PreChatFormSettings from './PreChatForm/Settings';
import WeeklyAvailability from './components/WeeklyAvailability';
import GreetingsEditor from 'shared/components/GreetingsEditor';
import ConfigurationPage from './settingsPage/ConfigurationPage';
import CollaboratorsPage from './settingsPage/CollaboratorsPage';
import CustomerSatisfactionPage from './settingsPage/CustomerSatisfactionPage';
import AutoSummaryPage from './settingsPage/AutoSummaryPage';
import WidgetBuilder from './WidgetBuilder';
import BotConfiguration from './components/BotConfiguration';
import WppconnectConfiguration from './components/WPPConnectConfiguration';
import WhatsappwebConfiguration from './components/WhatsAppWebConfiguration';
import FilePermissionPage from './settingsPage/FilePermissionPage';
import ReauthorizationPage from './settingsPage/ReauthorizationPage';
import WhatsappTemplatesPage from './templates/Index';
import ClosingReasonsPage from './closingReasons/Index';
import TemplateParameterizationPage from './templateParameterizations/Index';
import CallSettingsPage from './callSettings/Index';
import InboxQualitySettings from './components/InboxQualitySettings';
import BusinessManagerSettings from './components/BusinessManagerSettings';
import MigrateManagerSettings from './migrate/Index';

export default {
  components: {
    BotConfiguration,
    CollaboratorsPage,
    ConfigurationPage,
    CustomerSatisfactionPage,
    AutoSummaryPage,
    FacebookReauthorize,
    GreetingsEditor,
    PreChatFormSettings,
    SettingIntroBanner,
    SettingsSection,
    WeeklyAvailability,
    WidgetBuilder,
    WppconnectConfiguration,
    WhatsappwebConfiguration,
    FilePermissionPage,
    ReauthorizationPage,
    WhatsappTemplatesPage,
    ClosingReasonsPage,
    TemplateParameterizationPage,
    CallSettingsPage,
    InboxQualitySettings,
    BusinessManagerSettings,
    MigrateManagerSettings
  },
  mixins: [alertMixin, adminMixin, configMixin, inboxMixin],
  data() {
    return {
      avatarFile: null,
      avatarUrl: '',
      greetingEnabled: true,
      openConversationEnabled: true,
      tweetsEnabled: true,
      sendMessageSignature: false,
      blockTemplatesOnLowQuality: false,
      greetingMessage: '',
      emailCollectEnabled: false,
      locktoSingleConversation: false,
      allowMessagesAfterResolved: true,
      continuityViaEmail: true,
      selectedInboxName: '',
      channelWebsiteUrl: '',
      webhookUrl: '',
      channelWelcomeTitle: '',
      channelWelcomeTagline: '',
      selectedFeatureFlags: [],
      replyTime: '',
      selectedTabIndex: 0,
      selectedPortalSlug: '',
      showExtraMenu: false,
      extraMenuStyle: {},
      enableLocktoSingleConversationHours: false,
      locktoSingleConversationHours: 1,
      isRefreshingWhatsappToken: false,
      isRequestingWhatsappAuthorization: false,
      isWhatsappSdkLoaded: false,
      whatsappMessageHandler: null
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
      uiFlags: 'inboxes/getUIFlags',
      portals: 'portals/allPortals',
      appIntegrations: 'integrations/getAppIntegrations',
    }),
    isAutoSummaryAvailable() {
      const openAIIntegration = this.appIntegrations.find(
        integration => integration.id === 'openai'
      );
      return !!openAIIntegration?.hooks?.some(hook => !!hook.settings?.api_key);
    },
    selectedTabKey() {
      return this.tabs[this.selectedTabIndex]?.key;
    },
    whatsappAppId() {
      return window.chatwootConfig.whatsappAppId;
    },
    whatsappConfigurationId() {
      return window.chatwootConfig.whatsappConfigurationId;
    },
    whatsAppAPIProviderName() {
      if (this.isAWhatsAppCloudChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.WHATSAPP_CLOUD');
      }
      if (this.is360DialogWhatsAppChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.360_DIALOG');
      }
      if (this.isATwilioWhatsAppChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.TWILIO');
      }
      if (this.isGupshupWhatsAppChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.GUPSHUP');
      }
      return '';
    },
    mainTabs() {
      const priorityKeys = [
        'inbox_settings',
        'collaborators',
        'csat',
        'auto_summary',
        'businesshours',
        'botConfiguration',
        'whatsapp_templates',
        'call_settings',
        'number_quality',
        'business_manager',
      ];
      return this.tabs.filter(tab => priorityKeys.includes(tab.key));
    },
    extraTabs() {
      const priorityKeys = [
        'inbox_settings',
        'collaborators',
        'csat',
        'auto_summary',
        'businesshours',
        'botConfiguration',
        'whatsapp_templates',
        'number_quality',
        'business_manager',
      ];
      return this.tabs.filter(tab => !priorityKeys.includes(tab.key));
    },
    mainTabsIndex() {
      const idx = this.mainTabs.findIndex(t => t.key === this.selectedTabKey);
      return idx >= 0 ? idx : 0;
    },
    tabs() {
      let visibleToAllChannelTabs = [
        {
          key: 'inbox_settings',
          name: this.$t('INBOX_MGMT.TABS.SETTINGS'),
        },
        {
          key: 'collaborators',
          name: this.$t('INBOX_MGMT.TABS.COLLABORATORS'),
        },
        {
          key: 'csat',
          name: this.$t('INBOX_MGMT.TABS.CSAT'),
        },
        ...(this.isAutoSummaryAvailable
          ? [
              {
                key: 'auto_summary',
                name: this.$t('INBOX_MGMT.TABS.AUTO_SUMMARY'),
              },
            ]
          : []),
        {
          key: 'businesshours',
          name: this.$t('INBOX_MGMT.TABS.BUSINESS_HOURS'),
        },
        {
          key: 'botConfiguration',
          name: this.$t('INBOX_MGMT.TABS.BOT_CONFIGURATION'),
        },
      ];

      if (this.isAWebWidgetInbox) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'preChatForm',
            name: this.$t('INBOX_MGMT.TABS.PRE_CHAT_FORM'),
          },
          {
            key: 'widgetBuilder',
            name: this.$t('INBOX_MGMT.TABS.WIDGET_BUILDER'),
          },
        ];
      }

      if (this.isWPPConnectInbox) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'wppconnect',
            name: this.$t('INBOX_MGMT.TABS.WHATSAPP_WEB'),
          },
        ];
      }

      if (this.isWhatsAppWebChannel) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'whatsapp_web',
            name: this.$t('INBOX_MGMT.TABS.WHATSAPP_WEB'),
          },
        ];
      }

      if (this.isAWhatsAppChannel) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'file_permission',
            name: this.$t('INBOX_MGMT.TABS.FILES_DENIED'),
          },
        ];
      }

      if (this.isAWhatsAppChannel && this.isAdmin) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'whatsapp_templates',
            name: this.$t('INBOX_MGMT.TABS.TEMPLATES'),
          },
          {
            key: 'whatsapp_templates_admin',
            name: this.$t('INBOX_MGMT.TABS.TEMPLATES_ADMIN'),
          },
        ];
      }

      if (this.isAWhatsAppChannel) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'template_parameterization',
            name: this.$t('INBOX_MGMT.TABS.TEMPLATE_PARAMETERIZATION'),
          },
          {
            key: 'call_settings',
            name: this.$t('INBOX_MGMT.TABS.CALL_SETTINGS'),
          }
        ];
      }

      if (this.is360DialogCloudWhatsAppChannel) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'number_quality',
            name: this.$t('INBOX_MGMT.TABS.NUMBER_QUALITY'),
          },
          {
            key: 'business_manager',
            name: this.$t('INBOX_MGMT.TABS.BUSINESS_MANAGER'),
          },
        ];
      }

      if (this.canForceWhatsappTokenRefresh) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'reauthorization',
            name: this.$t('INBOX_MGMT.REAUTH'),
          },
        ];
      }

      if (
        this.isATwilioChannel ||
        this.isALineChannel ||
        this.isAPIInbox ||
        (this.isAnEmailChannel && !this.inbox.provider) ||
        (this.isAnEmailChannel && this.inbox.provider === 'microsoft') ||
        this.isAWhatsAppChannel ||
        this.isAWebWidgetInbox ||
        this.isVollChannel ||
        this.isWetalkieChannel ||
        this.isOmneChannel ||
        this.isMultimediaChannel ||
        this.isZendeskChannel ||
        this.isInfobipChannel
      ) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'configuration',
            name: this.$t('INBOX_MGMT.TABS.CONFIGURATION'),
          },
        ];
      }

      if (this.isAdmin) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'closing_reasons',
            name: this.$t('INBOX_MGMT.TABS.CLOSING_REASONS'),
          },
          {
            key: 'migrate_manager',
            name: this.$t('INBOX_MGMT.TABS.MIGRATE_MANAGER'),
          }
        ];
      }

      return visibleToAllChannelTabs;
    },
    currentInboxId() {
      return this.$route.params.inboxId;
    },
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.currentInboxId);
    },
    hasWhatsappTemplates() {
      if (!this.isAdmin) return false;

      return !!this.$store.getters['inboxes/getWhatsAppTemplates'](
        this.currentInboxId
      ).length;
    },
    inboxName() {
      if (this.isATwilioSMSChannel || this.isATwilioWhatsAppChannel) {
        return `${this.inbox.name} (${
          this.inbox.messaging_service_sid || this.inbox.phone_number
        })`;
      }
      if (this.isAWhatsAppChannel) {
        return `${this.inbox.name} (${this.inbox.phone_number})`;
      }
      if (this.isAnEmailChannel) {
        return `${this.inbox.name} (${this.inbox.email})`;
      }
      return this.inbox.name;
    },
    canLocktoSingleConversation() {
      return this.isASmsInbox || this.isAWhatsAppChannel || this.isATelegramChannel;
    },
    inboxNameLabel() {
      if (this.isAWebWidgetInbox) {
        return this.$t('INBOX_MGMT.ADD.WEBSITE_NAME.LABEL');
      }
      return this.$t('INBOX_MGMT.ADD.CHANNEL_NAME.LABEL');
    },
    inboxNamePlaceHolder() {
      if (this.isAWebWidgetInbox) {
        return this.$t('INBOX_MGMT.ADD.WEBSITE_NAME.PLACEHOLDER');
      }
      return this.$t('INBOX_MGMT.ADD.CHANNEL_NAME.PLACEHOLDER');
    },
    textAreaChannels() {
      if (
        this.isATwilioChannel ||
        this.isATwitterInbox ||
        this.isAFacebookInbox
      )
        return true;
      return false;
    },
    isEmbeddedSignupWhatsApp() {
      return this.inbox.provider_config?.source === 'embedded_signup';
    },
    whatsappUnauthorized() {
      return (
        this.isAWhatsAppCloudChannel &&
        this.isEmbeddedSignupWhatsApp &&
        this.inbox.reauthorization_required
      );
    },
    whatsappRegistrationIncomplete() {
      if (
        !this.isAWhatsAppCloudChannel ||
        !this.isEmbeddedSignupWhatsApp
      ) {
        return false;
      }

      return true;
    },
    canForceWhatsappTokenRefresh() {
      return this.isAWhatsAppCloudChannel && this.isEmbeddedSignupWhatsApp;
    },
  },
  watch: {
    $route(to) {
      if (to.name === 'settings_inbox_show') {
        this.fetchInboxSettings();
      }
    },
    // Mantém as flags em sincronia quando são salvas por outra aba (ex.: Construtor de Widget)
    'inbox.selected_feature_flags'(flags) {
      this.selectedFeatureFlags = flags || [];
    },
    locktoSingleConversation(newValue){
      if(!newValue){
        this.enableLocktoSingleConversationHours = false;
      }
    }
  },
  mounted() {
    this.fetchInboxSettings();
    this.fetchPortals();
    this.$store.dispatch('integrations/get');
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    if (this.whatsappMessageHandler) {
      window.removeEventListener('message', this.whatsappMessageHandler);
      this.whatsappMessageHandler = null;
    }
  },
  methods: {
    fetchPortals() {
      this.$store.dispatch('portals/index');
    },
    handleFeatureFlag(e) {
      this.selectedFeatureFlags = this.toggleInput(
        this.selectedFeatureFlags,
        e.target.value
      );
    },
    toggleInput(selected, current) {
      if (selected.includes(current)) {
        const newSelectedFlags = selected.filter(flag => flag !== current);
        return newSelectedFlags;
      }
      return [...selected, current];
    },
    onTabChange(selectedTabIndex) {
      this.selectedTabIndex = selectedTabIndex;
    },
    onMainTabChange(mainIndex) {
      const mainTab = this.mainTabs[mainIndex];
      if (!mainTab) return;
      const overallIndex = this.tabs.findIndex(t => t.key === mainTab.key);
      if (overallIndex !== -1) {
        this.selectedTabIndex = overallIndex;
      }
    },
    fetchInboxSettings() {
      this.selectedTabIndex = 0;
      this.selectedAgents = [];
      this.$store.dispatch('agents/get');
      this.$store.dispatch('teams/get');
      this.$store.dispatch('labels/get');
      this.$store.dispatch('inboxes/get').then(() => {
        this.avatarUrl = this.inbox.avatar_url;
        this.selectedInboxName = this.inbox.name;
        this.webhookUrl = this.inbox.webhook_url;
        this.greetingEnabled = this.inbox.greeting_enabled || false;
        this.openConversationEnabled =
          this.inbox.open_conversation_enabled || false;
        this.tweetsEnabled = this.inbox.tweets_enabled || false;
        this.greetingMessage = this.inbox.greeting_message || '';
        this.emailCollectEnabled = this.inbox.enable_email_collect;
        this.allowMessagesAfterResolved =
          this.inbox.allow_messages_after_resolved;
        this.continuityViaEmail = this.inbox.continuity_via_email;
        this.channelWebsiteUrl = this.inbox.website_url;
        this.channelWelcomeTitle = this.inbox.welcome_title;
        this.channelWelcomeTagline = this.inbox.welcome_tagline;
        this.sendMessageSignature = this.inbox.send_message_signature;
        this.blockTemplatesOnLowQuality =
          this.inbox.block_templates_on_low_quality || false;
        this.selectedFeatureFlags = this.inbox.selected_feature_flags || [];
        this.replyTime = this.inbox.reply_time;
        this.locktoSingleConversation = this.inbox.lock_to_single_conversation;
        this.selectedPortalSlug = this.inbox.help_center
          ? this.inbox.help_center.slug
          : '';
        if(this.inbox.hasOwnProperty("lock_to_single_conversation_hours") && this.inbox.lock_to_single_conversation_hours != null){
          this.locktoSingleConversationHours = this.inbox.lock_to_single_conversation_hours;
          this.enableLocktoSingleConversationHours = true;
        }
      });
    },
    async updateInbox() {
      try {
        const payload = {
          id: this.currentInboxId,
          name: this.selectedInboxName,
          enable_email_collect: this.emailCollectEnabled,
          allow_messages_after_resolved: this.allowMessagesAfterResolved,
          greeting_enabled: this.greetingEnabled,
          open_conversation_enabled: this.openConversationEnabled,
          greeting_message: this.greetingMessage || '',
          portal_id: this.selectedPortalSlug
            ? this.portals.find(
                portal => portal.slug === this.selectedPortalSlug
              ).id
            : null,
          lock_to_single_conversation: this.locktoSingleConversation,
          lock_to_single_conversation_hours: !this.locktoSingleConversation && this.enableLocktoSingleConversationHours ? parseInt(this.locktoSingleConversationHours) : null,
          send_message_signature: this.sendMessageSignature,
          block_templates_on_low_quality: this.blockTemplatesOnLowQuality,
          channel: {
            widget_color: this.inbox.widget_color,
            website_url: this.channelWebsiteUrl,
            webhook_url: this.webhookUrl,
            welcome_title: this.channelWelcomeTitle || '',
            welcome_tagline: this.channelWelcomeTagline || '',
            selectedFeatureFlags: this.selectedFeatureFlags,
            reply_time: this.replyTime || 'in_a_few_minutes',
            tweets_enabled: this.tweetsEnabled,
            continuity_via_email: this.continuityViaEmail,
          },
        };
        if (this.avatarFile) {
          payload.avatar = this.avatarFile;
        }
        await this.$store.dispatch('inboxes/updateInbox', payload);
        this.showAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(
          error.message || this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE')
        );
      }
    },
    handleImageUpload({ file, url }) {
      this.avatarFile = file;
      this.avatarUrl = url;
    },
    async handleAvatarDelete() {
      try {
        await this.$store.dispatch(
          'inboxes/deleteInboxAvatar',
          this.currentInboxId
        );
        this.avatarFile = null;
        this.avatarUrl = '';
        this.showAlert(this.$t('INBOX_MGMT.DELETE.API.AVATAR_SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(
          error.message
            ? error.message
            : this.$t('INBOX_MGMT.DELETE.API.AVATAR_ERROR_MESSAGE')
        );
      }
    },
    toggleExtraMenu() {
      this.showExtraMenu = !this.showExtraMenu;
      if (this.showExtraMenu) {
        this.$nextTick(() => this.positionExtraMenu());
      }
    },
    positionExtraMenu() {
      const button = this.$refs.extraButton?.$el || this.$refs.extraButton;
      const menu = this.$refs.extraMenu;
      if (!button || !menu) return;

      const buttonRect = button.getBoundingClientRect();
      const wrapperRect = this.$refs.tabsWrapper.getBoundingClientRect();

      const left = buttonRect.left - wrapperRect.left;
      const top = buttonRect.bottom - wrapperRect.top + 4;

      this.extraMenuStyle = {
        position: 'absolute',
        left: `${left}px`,
        top: `${top}px`,
      };
    },
    handleClickOutside(event) {
      const wrapper = this.$refs.tabsWrapper;
      if (wrapper && !wrapper.contains(event.target)) {
        this.showExtraMenu = false;
      }
    },
    onMainTabChange(mainIndex) {
      const mainTab = this.mainTabs[mainIndex];
      if (!mainTab) return;
      const overallIndex = this.tabs.findIndex(t => t.key === mainTab.key);
      if (overallIndex !== -1) {
        this.selectedTabIndex = overallIndex;
      }
    },
    selectExtraTab(tab) {
      this.showExtraMenu = false;
      const index = this.tabs.findIndex(t => t.key === tab.key);
      if (index !== -1) {
        this.selectedTabIndex = index;
      }
    },
    async ensureWhatsappSdkLoaded() {
      if (this.isWhatsappSdkLoaded) {
        return;
      }

      if (!this.whatsappAppId) {
        throw new Error(this.$t('INBOX.REAUTHORIZE.WHATSAPP_APP_ID_MISSING'));
      }

      if (!this.whatsappConfigurationId) {
        throw new Error(this.$t('INBOX.REAUTHORIZE.WHATSAPP_CONFIG_ID_MISSING'));
      }

      await setupFacebookSdk(
        this.whatsappAppId,
        window.chatwootConfig?.whatsappApiVersion
      );
      this.isWhatsappSdkLoaded = true;
    },
    async reauthorizeWhatsApp(params) {
      const response = await whatsappChannel.reauthorizeWhatsApp({
        inboxId: this.inbox.id,
        ...params,
      });

      if (response.data.success) {
        this.showAlert(this.$t('INBOX.REAUTHORIZE.SUCCESS'));
      } else {
        throw new Error(response.data.message || this.$t('INBOX.REAUTHORIZE.ERROR'));
      }
    },
    async handleWhatsappEmbeddedSignupEvents(data, authCode) {
      if (!data || typeof data !== 'object') {
        return;
      }

      if (data.event === 'FINISH') {
        const businessData = data.data;

        if (isValidBusinessData(businessData) && businessData.phone_number_id) {
          await this.reauthorizeWhatsApp({
            code: authCode,
            business_id: businessData.business_id,
            waba_id: businessData.waba_id,
            phone_number_id: businessData.phone_number_id,
          });
          return;
        }

        throw new Error(this.$t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.INVALID_BUSINESS_DATA'));
      }

      if (data.event === 'CANCEL') {
        throw new Error(this.$t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.CANCELLED'));
      }

      if (data.event === 'error') {
        throw new Error(data.error_message || this.$t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.SIGNUP_ERROR'));
      }
    },
    startWhatsappEmbeddedSignup(authCode) {
      if (this.whatsappMessageHandler) {
        window.removeEventListener('message', this.whatsappMessageHandler);
      }

      this.whatsappMessageHandler = createMessageHandler(data =>
        this.handleWhatsappEmbeddedSignupEvents(data, authCode)
      );
      window.addEventListener('message', this.whatsappMessageHandler);
    },
    async handleLoginAndReauthorizeWhatsApp() {
      await this.ensureWhatsappSdkLoaded();

      const authCode = await initWhatsAppEmbeddedSignup(
        this.whatsappConfigurationId
      );

      const existingConfig = this.inbox.provider_config;
      if (
        existingConfig &&
        existingConfig.business_account_id &&
        existingConfig.phone_number_id
      ) {
        await this.reauthorizeWhatsApp({
          code: authCode,
          business_id: existingConfig.business_account_id,
          waba_id: existingConfig.business_account_id,
          phone_number_id: existingConfig.phone_number_id,
        });
        return;
      }

      this.startWhatsappEmbeddedSignup(authCode);
    },
    async requestWhatsappReauthorization() {
      this.isRequestingWhatsappAuthorization = true;
      try {
        await this.handleLoginAndReauthorizeWhatsApp();
      } catch (error) {
        this.showAlert(error.message || this.$t('INBOX.REAUTHORIZE.ERROR'));
      } finally {
        this.isRequestingWhatsappAuthorization = false;
      }
    },
    async forceTokenRefresh() {
      this.isRefreshingWhatsappToken = true;
      try {
        const response = await whatsappChannel.refreshWhatsAppToken({
          inboxId: this.inbox.id,
        });

        if (response.data.success) {
          this.showAlert(response.data.message || 'Token atualizado com sucesso');
        } else {
          this.showAlert(response.data.message || this.$t('INBOX.REAUTHORIZE.ERROR'));
        }
      } catch (error) {
        this.showAlert(error.message || this.$t('INBOX.REAUTHORIZE.ERROR'));
      } finally {
        this.isRefreshingWhatsappToken = false;
      }
    },
  },
  validations: {
    webhookUrl: {
      shouldBeUrl,
    },
    selectedInboxName: {},
  },
};
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/variables';
@import '~dashboard/assets/scss/mixins';

.settings {
  background: $color-white;

  .settings--tabs {
    ::v-deep .tabs {
      padding: 0;
    }
  }

  .settings--content {
    div:last-child {
      border-bottom: 0;
    }
  }

  .tabs {
    padding: 0;
    margin-bottom: -1px;
  }
}

.widget--feature-flag {
  padding-top: var(--space-small);
}

.settings-item {
  padding-bottom: var(--space-normal);

  .help-text {
    font-style: normal;
    color: var(--b-500);
    padding-bottom: var(--space-smaller);
  }
}

.settings--content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--space-medium);
  margin-bottom: var(--space-medium);
}

.settings-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.settings--tabs-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}

.extra-tabs-trigger {
  position: relative;
  cursor: pointer;
}

.extra-tabs__menu {
  position: absolute;
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  z-index: 100;
  list-style: none;
  padding: 0.5rem 0;
  min-width: 180px;
}

.extra-tabs__item {
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: var(--font-size-mini);
  white-space: nowrap;
}

.extra-tabs__item:hover {
  background: var(--b-100);
}
</style>
